import type { ApiClient } from '../client';
import type {
  AddWebsiteDomainRequest,
  AddWebsiteDomainResponse,
  ListWebsiteDomainsResponse,
  WebsiteCmsPayload,
  WebsiteDomainDto,
  WebsiteThemesResponse,
} from '../types/website';

export function bindWebsite(client: ApiClient) {
  return {
    async getWebsiteCms(tenantId?: string | number) {
      return client.request<WebsiteCmsPayload>('/website', {
        tenantId,
        suppressSessionExpiry: tenantId != null,
      });
    },

    async putWebsiteCms(body: WebsiteCmsPayload, tenantId?: string | number) {
      return client.request<WebsiteCmsPayload>('/website', {
        method: 'PUT',
        body: JSON.stringify(body),
        tenantId,
        suppressSessionExpiry: tenantId != null,
      });
    },

    async listWebsiteThemes(tenantId?: string | number) {
      return client.request<WebsiteThemesResponse>('/website/themes', {
        tenantId,
        suppressSessionExpiry: tenantId != null,
      });
    },

    async listWebsiteDomains(tenantId?: string | number) {
      return client.request<ListWebsiteDomainsResponse>('/website/domains', {
        tenantId,
        suppressSessionExpiry: tenantId != null,
      });
    },

    async addWebsiteDomain(body: AddWebsiteDomainRequest, tenantId?: string | number) {
      return client.request<AddWebsiteDomainResponse>('/website/domains', {
        method: 'POST',
        body: JSON.stringify(body),
        tenantId,
        suppressSessionExpiry: tenantId != null,
      });
    },

    async activateWebsiteDomain(domainId: string, tenantId?: string | number) {
      return client.request<WebsiteDomainDto>(
        `/website/domains/${encodeURIComponent(domainId)}/activate`,
        {
          method: 'POST',
          tenantId,
          suppressSessionExpiry: tenantId != null,
        }
      );
    },

    async deleteWebsiteDomain(domainId: string, tenantId?: string | number) {
      return client.request<void>(`/website/domains/${encodeURIComponent(domainId)}`, {
        method: 'DELETE',
        tenantId,
        suppressSessionExpiry: tenantId != null,
      });
    },
  };
}
